import { defineMessages, injectIntl } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Popover } from 'spa/components/popover'
import { PopoverHeading } from '../typography/popover_heading'
import { SongPropType } from 'spa/api/songs'
import { SongsList } from 'spa/components/songs_list'
import { useLocation } from 'react-router-dom'
import ActionConfirm from '../../clear_confirm/clear_confirm'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import styles from './styles'

const localizeMessages = defineMessages({
  cancelButton: {
    id: 'djcity.records.queue.clear.button.cancel',
    defaultMessage: 'cancel',
  },
  clearButton: {
    id: 'djcity.records.queue.clear.button.confirmation',
    defaultMessage: 'yes, clear queue',
  },
  title: {
    id: 'djcity.records.queue.clear.confirmation',
    defaultMessage: 'Are You Sure You Want to Clear All Tracks in Your Queue?',
  },
  track: {
    id: 'djcity.records.queue.player.track',
    defaultMessage: 'track',
  },
  tracks: {
    id: 'djcity.records.queue.player.tracks',
    defaultMessage: 'tracks',
  },
  message: {
    id: 'djcity.records.queue.player.message',
    defaultMessage: 'in preview queue',
  },
  played: {
    id: 'djcity.records.queue.player.already_played',
    defaultMessage: 'previous',
  },
  playingNow: {
    id: 'djcity.records.queue.player.playing_now',
    defaultMessage: 'playing now',
  },
  playingNext: {
    id: 'djcity.records.queue.player.next_play',
    defaultMessage: 'next',
  },
})

const QueuePopover = props => {
  const location = useLocation()
  const [clearScreen, setClearScreen] = useState(false)
  const [isClosed, setIsClosed] = useState(true)

  const { clearQueue, songIdx, songs, removeSongFromQueue, intl } = props

  const onToggleList = () => {
    setClearScreen(!clearScreen)
  }

  const handleClickClearQueue = () => {
    clearQueue()
    setClearScreen(!clearScreen)
  }

  useEffect(() => {
    setIsClosed(true)
  }, [location, setIsClosed])

  const handleClickInside = useCallback(
    cb => {
      setIsClosed(!isClosed)
      cb()
    },
    [setIsClosed]
  )

  return (
    <Popover
      arrow
      className={styles.playerPopover}
      closeOnScroll={false}
      contentClassName={styles.queuePopoverContent}
      openPopover={isClosed}
      renderTrigger={({ handleClick, ref }) => (
        <button
          className={classNames('cleanButton', styles.queueButton)}
          onClick={() => handleClickInside(handleClick)}
          ref={ref}
        >
          <svg
            className={styles.queueicon}
            fill="none"
            viewBox="0 0 21 15"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1C0 0.801088 0.0790178 0.610322 0.21967 0.46967C0.360322 0.329018 0.551088 0.25 0.75 0.25H17.25C17.4489 0.25 17.6397 0.329018 17.7803 0.46967C17.921 0.610322 18 0.801088 18 1C18 1.19891 17.921 1.38968 17.7803 1.53033C17.6397 1.67098 17.4489 1.75 17.25 1.75H0.75C0.551088 1.75 0.360322 1.67098 0.21967 1.53033C0.0790178 1.38968 0 1.19891 0 1ZM9.75 6.25H0.75C0.551088 6.25 0.360322 6.32902 0.21967 6.46967C0.0790178 6.61032 0 6.80109 0 7C0 7.19891 0.0790178 7.38968 0.21967 7.53033C0.360322 7.67098 0.551088 7.75 0.75 7.75H9.75C9.94891 7.75 10.1397 7.67098 10.2803 7.53033C10.421 7.38968 10.5 7.19891 10.5 7C10.5 6.80109 10.421 6.61032 10.2803 6.46967C10.1397 6.32902 9.94891 6.25 9.75 6.25ZM9.75 12.25H0.75C0.551088 12.25 0.360322 12.329 0.21967 12.4697C0.0790178 12.6103 0 12.8011 0 13C0 13.1989 0.0790178 13.3897 0.21967 13.5303C0.360322 13.671 0.551088 13.75 0.75 13.75H9.75C9.94891 13.75 10.1397 13.671 10.2803 13.5303C10.421 13.3897 10.5 13.1989 10.5 13C10.5 12.8011 10.421 12.6103 10.2803 12.4697C10.1397 12.329 9.94891 12.25 9.75 12.25ZM20.25 10C20.2499 10.1271 20.2176 10.2522 20.1559 10.3634C20.0942 10.4746 20.0053 10.5682 19.8975 10.6356L13.8975 14.3856C13.784 14.4566 13.6536 14.4958 13.5198 14.4994C13.386 14.5029 13.2537 14.4706 13.1366 14.4057C13.0195 14.3408 12.9219 14.2458 12.8539 14.1305C12.786 14.0152 12.7501 13.8838 12.75 13.75V6.25C12.7501 6.11615 12.786 5.98476 12.8539 5.86946C12.9219 5.75416 13.0195 5.65916 13.1366 5.5943C13.2537 5.52945 13.386 5.4971 13.5198 5.50063C13.6536 5.50416 13.784 5.54344 13.8975 5.61438L19.8975 9.36438C20.0053 9.43176 20.0942 9.52545 20.1559 9.63663C20.2176 9.74782 20.2499 9.87286 20.25 10ZM18.0853 10L14.25 7.60281V12.3972L18.0853 10Z"
              fill="white"
            />
          </svg>
        </button>
      )}
      variant="light"
    >
      <PopoverHeading className={styles.queuePopoverHeading}>
        {songs.length}{' '}
        {songs.length === 1
          ? intl.formatMessage(localizeMessages.track)
          : intl.formatMessage(localizeMessages.tracks)}{' '}
        {intl.formatMessage(localizeMessages.message)}
        <FontAwesomeIcon
          className={styles.trash}
          icon={['far', 'trash']}
          onClick={onToggleList}
        />
      </PopoverHeading>
      {!clearScreen ? (
        <SongsList
          className={styles.queuePopoverTracksList}
          fixedPopover
          removeSongFromQueue={removeSongFromQueue}
          scrollToBottom={true}
          songIdx={songIdx}
          songs={songs}
          variant="dark"
        />
      ) : (
        <ActionConfirm
          primaryAction={() => onToggleList()}
          primaryActionText={intl.formatMessage(localizeMessages.cancelButton)}
          secondaryAction={() => handleClickClearQueue()}
          secondaryActionText={intl.formatMessage(localizeMessages.clearButton)}
          title={intl.formatMessage(localizeMessages.title)}
        />
      )}
    </Popover>
  )
}

QueuePopover.propTypes = {
  clearQueue: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  removeSongFromQueue: PropTypes.func,
  songIdx: PropTypes.number,
  songs: PropTypes.arrayOf(SongPropType).isRequired,
}

const ConnectedQueuePopover = injectIntl(QueuePopover)

export { ConnectedQueuePopover as QueuePopover }
